const toggleMobileNav = () => {
	const mobileNav = document.querySelector('.mobile-nav');
	const buttonOpen = document.querySelector('.header__mobile-nav-toggle');
	const buttonClose = document.querySelector('.mobile-nav__button-close');
	
	buttonOpen.addEventListener('click', () => {
		mobileNav.classList.add('mobile-nav--active');
	});
	
	buttonClose.addEventListener('click', () => {
		mobileNav.classList.remove('mobile-nav--active');
	});
	
	window.addEventListener('resize', () => {
		if (document.documentElement.clientWidth >= 1024 && mobileNav.classList.contains('mobile-nav--active')) {
			mobileNav.classList.remove('mobile-nav--active');
		}
	});
}

export {toggleMobileNav};
